import {Link} from '../ui/ScopedLink';
import {DataTable} from '../ui/DataTable';
import {StatusBadge} from '../ui/StatusBadge';
import type {Contact} from './Contacts';

export function ContactDirectoryTable({rows,canEdit}:{rows:Contact[];canEdit:boolean}){
 const path=(row:Contact)=>'/records/'+row.type.toLowerCase()+'/'+row.id;
 return <DataTable caption={<span className="sr-only">People and organisations in this directory view</span>} scrollLabel="Contact records" rows={rows} getRowKey={row=>row.type+':'+row.id}
 rowHeader={{id:'name',header:'Name',render:row=><Link className="data-table__record-link" to={path(row)}>{row.name}</Link>}}
 columns={[
  {id:'type',header:'Record type',render:row=>row.type},
  {id:'relationships',header:'Relationships',render:row=>
<>{row.roles.slice(0,2).map((role,index)=>
<span className="register-secondary" key={role.code+':'+index} title={role.status}>{role.label}</span>)}{!row.roles.length&&'No advanced roles recorded'}{row.roles.length>2&&<details>
<summary>{row.roles.length-2} more roles</summary>{row.roles.slice(2).map((role,index)=>
<p key={role.code+':'+index}>{role.label} · {role.status}</p>)}</details>}</>},
  {id:'buildings',header:'Buildings',align:'right',render:row=>row.building_count},
  {id:'premises',header:'Premises',align:'right',render:row=>row.premises_count},
  {id:'status',header:'Recorded status',render:row=><StatusBadge text={row.status||'Not recorded'}/>},
  ...(canEdit?[{id:'edit',header:<span className="sr-only">Edit record</span>,render:(row:Contact)=><Link to={path(row)+'?mode=edit'} aria-label={'Edit '+row.name}>Edit</Link>}]:[]),
 ]}/>;
}
